module Meevo.Plugins.OnlineBookingSettings {
    import SettingsDto = Meevo.Model.SettingsDto;
    import SecurityAccessEnum = Meevo.Model.SecurityAccessEnum;
    "use strict";

    /**
    * Main Section of OnlineBooking Settings 
    */
    export interface ITypeScanTypeEnum extends Model.EnumDto {
        checked?: boolean;
        sortOrder?: number;
    }

    export class MainSection extends Meevo.Components.CommonClasses.SettingsSectionBase {
        private wysiwygApi: Components.Common.IWysiwygApi;
        private wysiwygConfig: Components.Common.IWysiwygConfig;
        private scanDateTypesCheckBoxes: ITypeScanTypeEnum[];
        private scanTimeTypesCheckBoxes: ITypeScanTypeEnum[];

        constructor(
            sectionId: number,
            displayNameContentKey: string,
            template: string,
            isPrimarySection: boolean,
            handlesOwnCrud: boolean,
            baseEndpoint: string,
            sectionEndpoint: string,
            loggingService: Meevo.Components.Logging.ILoggingService,
            dataService: Meevo.Components.CommonClasses.ICommonDataService,
            noun: Meevo.Model.NounEnum = null,
            identityService: Components.Common.IIdentityService = null,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected $scope: angular.IScope,
            protected $q: ng.IQService,
            protected securityChecker: Meevo.Components.Common.ISecurityService,
            private surchargeSecurityKey: string,
            sectionSecurityKey?: string,
            
        ) {
            super(sectionId, displayNameContentKey, template, isPrimarySection, handlesOwnCrud, baseEndpoint, sectionEndpoint, loggingService, dataService, noun, identityService, modalService, sectionSecurityKey);

            /*
            *  wysiwyg-edit => https://github.com/psergus/ngWYSIWYG/blob/master/src/js/wysiwygEdit.js
            */
            this.wysiwygConfig = {
                sanitize: false,
                fontAwesome: false,
                toolbar: [
                    //{ name: 'basicStyling', items: ['bold', 'italic', 'underline', 'strikethrough', 'subscript', 'superscript', '-', 'leftAlign', 'centerAlign', 'rightAlign', 'blockJustify', '-'] },
                    { name: 'basicStyling', items: ['bold', 'italic', 'underline', 'strikethrough', '-'] },
                    //{ name: 'paragraph', items: ['orderedList', 'unorderedList', 'outdent', 'indent', '-'] },
                    { name: 'doers', items: ['removeFormatting', 'undo', 'redo', '-'] },
                    { name: 'colors', items: ['fontColor', 'backgroundColor', '-'] },
                    //{ name: 'links', items: ['image', 'hr', 'symbols', 'link', 'unlink', '-'] },
                    { name: 'links', items: ['hr', 'link', 'unlink', '-'] },
                    //{ name: 'tools', items: ['print', '-'] },
                    { name: 'styling', items: ['font', 'size', 'format'] },
                ]
            };
            this.wysiwygApi = {
                scope: this.$scope,
                insertImage: () => {
                    const deferred = this.$q.defer();
                    const origin = window.location.origin;
                    setTimeout(() => {
                        var image = prompt('Please enter the file name ...', '/assets/images/meevoStore/');
                        if (image) {
                            deferred.resolve('<img src="' + origin + image + '" style="width: 50%;">');
                        } else {
                            deferred.reject(null);
                        }
                    }, 1000);
                    return deferred.promise;
                },
            }

        }

        protected defaultReferralTypeDetail: Model.DataDetail = {};
        protected referralTypeCriteria: any = {};

        private allBusinessTypeDetail: Model.BusinessTypeDetail = {
            displayName: "All Business Types",
            id: "00000000-0000-0000-0000-000000000001"
        };

        private _businessTypeDetail: Model.BusinessTypeDetail = {};

        get businessTypeDetail(): Model.BusinessTypeDetail {
            return this._businessTypeDetail;
        }

        set businessTypeDetail(value: Model.BusinessTypeDetail) {
            this._businessTypeDetail = _.isEmpty(value) ? this.identityService.userBusinessTypes[0] : value;
        }


        minimumThresholdtime(): any[] {

            let minutes = _.range(15, 60, 15).map(m => ({ 'key': m + 'm', 'value': m /60}))
            let hours = _.range(1, 73, 1).map(h => ({ 'key': h + 'hr', 'value': h }))
            let result = [...minutes , ...hours]

            return result
        }
            

        public defaultBusinessTypeId = this.allBusinessTypeDetail.id;

        activate(): void {
            super.activate();
            if (this.model.loginRequiredMode === null || this.model.loginRequiredMode === undefined) {
                this.model.loginRequiredMode = this.model.initialLoginRequired ? 1 : 2;
            }
            // update initial load of default merchant account
            this.updateBusinessTypes();
            if (this.identityService.inCentralOfficeMode()) {
                this.updateModel();
            }
            this.defaultReferralTypeDetail = {
                displayName: this.model.defaultReferralTypeDisplayName,
                id: this.model.defaultReferralTypeId
            };
            this.dataService.getEnumList(Model.EnumTypeEnum.ScanDateTypeEnum).then((res) => {
                this.scanDateTypesCheckBoxes = res;
                this.bitToScanDateType();
            });
            this.dataService.getEnumList(Model.EnumTypeEnum.ScanTimeTypeEnum).then((res) => {
                const exclusions = [2164, 2165];
                this.scanTimeTypesCheckBoxes = res.filter(r => !(exclusions.indexOf(r.id) > -1));
                this.parseScanTimeTypes();
            });

            const request = {
	            criteria: {
		            getDefaultAccountOnly: true
	            }
            };
             let merchantUri = `/${Meevo.AppSettings.Default.API_ROOT}/merchantAccount/List`

           
      
            let resolve: Array<angular.IPromise<any>> = [];
            resolve.push(this.dataService.customMethodData(merchantUri,'POST',request))
            resolve.push(this.securityChecker.checkModuleAccess(this.surchargeSecurityKey))
 
            this.$q.all(resolve).then(res=>{
                const merchantAccount: Model.MerchantAccount = res[0].data[0];
                 let surchargeUri = `/${Meevo.AppSettings.Default.API_ROOT}/merchantAccount/${merchantAccount.id}/surcharges`
                 this.model.showSurcharge = false;
                if(merchantAccount.merchantProviderId === 7  &&(res[1] === SecurityAccessEnum.Grant)){
                     this.dataService.customMethodData(surchargeUri,'GET','').then((response: any)=>{
                        let surchargeSettingEnabled = response.data.isSurchargeEnabled;
                        let surchargeCreditIsEnabled = response.data.surcharges.find(charges =>{
                               return charges.amount >0 && charges.isEnabled
                        })
                            this.model.showSurcharge = !!surchargeSettingEnabled && !!surchargeCreditIsEnabled
                      })
                 }
            })

            

        }

        parseScanTimeTypes() {
            this.scanTimeTypesCheckBoxes.forEach(checkBox => { checkBox.checked = false });
            if (Model.Guard.isSomething(this.model.scanTimeTypeAvailableOptions)) {
                const missing = this.scanTimeTypesCheckBoxes.filter(s => !(this.model.scanTimeTypeAvailableOptions.indexOf(s.id) > -1));
                const found = this.scanTimeTypesCheckBoxes.filter(s => (this.model.scanTimeTypeAvailableOptions.indexOf(s.id) > -1));
                found.forEach(checkBox => { checkBox.checked = true });
                this.scanTimeTypesCheckBoxes = [...found, ...missing];
            }

        }

        public updateBusinessTypes(): void {
            if (this.identityService.userBusinessTypes.length === 1 &&
                this.identityService.tenantBusinessTypeCount === 1) {
                this.businessTypeDetail = this.allBusinessTypeDetail;
            }
            else if (this.identityService.tenantBusinessTypeCount > 1 && this.identityService.userBusinessTypes.length > 0 )
                this.businessTypeDetail = this.identityService.userBusinessTypes[0];
            
        }

        public updateDefaultReferralType(): void {
            if (this.defaultReferralTypeDetail) {
                this.model.defaultReferralTypeId = this.defaultReferralTypeDetail.id;
                this.model.defaultReferralTypeDisplayName = this.defaultReferralTypeDetail.displayName
            }
        }

        checkFieldPermissions(value): boolean {

            return true
        }

        public loginRequiredModeOptions = [
            { value: 0, labelKey: 'LABEL_AOB_LOGIN_REQUIRED_MODE_OPTIONAL' },
            { value: 1, labelKey: 'LABEL_AOB_LOGIN_REQUIRED_MODE_TO_SEE_AVAILABILITY' },
            { value: 2, labelKey: 'LABEL_AOB_LOGIN_REQUIRED_MODE_TO_BOOK' }
        ];

        maxWaitTemp: Number = 0;

        public updateModel(): void {

            let uri = `/${Meevo.AppSettings.Default.API_ROOT}${this.baseEndpoint}${this.sectionEndpoint}`;

            if (this.businessTypeDetail) {
                this.model.businessTypeId = this.businessTypeDetail.id;

                let parameters = {
                    businessTypeId: this.model.businessTypeId
                }
                this.dataService.customMethodData(uri, 'GET', '', parameters).then((results: any) => {
                    let temp = this.businessTypeDetail;
                    this.model = results.data;
                    this.businessTypeDetail = temp;
                    this.model.businessTypeId = temp.id;
                    this.updateDefaultReferralTypeFromModel();
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                    if (this.model.loginRequiredMode === null || this.model.loginRequiredMode === undefined) {
                        this.model.loginRequiredMode = this.model.initialLoginRequired ? 1 : 2;
                    }
                });
            }

        }

        public setCriteriaReferralType(): void {

            if (this.identityService.inCentralOfficeMode()) {
                this.referralTypeCriteria.coSearchType = Meevo.Model.CoSearchType.CentralOffice;
                this.referralTypeCriteria.coBusinessTypeId = this.model.businessTypeId || this.businessTypeDetail.id || this.defaultBusinessTypeId;
                if (this.identityService.userBusinessTypes.length === 1 && this.identityService.tenantBusinessTypeCount === 1) {
                    this.referralTypeCriteria.coBusinessTypeId = null;
                }
                this.referralTypeCriteria.coSearchResultFilter = Meevo.Model.CoSearchResultsFilter.LocationOverrides;
            } else {
                this.referralTypeCriteria = "";
            }
        }

        public incrementTimeSpinner(): void {
            if (this.model.maximumWaitTimeBetweenServicesInMinutes > 0 &&
                this.model.maximumWaitTimeBetweenServicesInMinutes < 15) {
                if (this.maxWaitTemp < this.model.maximumWaitTimeBetweenServicesInMinutes) {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 15;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                } else {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 0;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                }
            } else if (this.model.maximumWaitTimeBetweenServicesInMinutes > 15 &&
                this.model.maximumWaitTimeBetweenServicesInMinutes < 30) {
                if (this.maxWaitTemp < this.model.maximumWaitTimeBetweenServicesInMinutes) {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 30;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                } else {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 15;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                }
            } else if (this.model.maximumWaitTimeBetweenServicesInMinutes > 30 &&
                this.model.maximumWaitTimeBetweenServicesInMinutes < 45) {
                if (this.maxWaitTemp < this.model.maximumWaitTimeBetweenServicesInMinutes) {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 45;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                } else {
                    this.model.maximumWaitTimeBetweenServicesInMinutes = 30;
                    this.maxWaitTemp = this.model.maximumWaitTimeBetweenServicesInMinutes;
                }
            }
        }

        public turnOffEnableResource(){
            if (this.model.maximumNumberOfGuests === 0) {
                this.model.enableResourceSharing = false;
            }
        }

        private updateDefaultReferralTypeFromModel() {
            this.defaultReferralTypeDetail = {
                displayName: this.model.defaultReferralTypeDisplayName,
                id: this.model.defaultReferralTypeId
            };
        }

        rollbackChanges(): void {
            super.rollbackChanges();
            this.updateDefaultReferralTypeFromModel();
            this.bitToScanDateType();
            this.parseScanTimeTypes();
        }

        sort = { sortBy: null, sortDirection: Model.SortDirection.Descending };
        criteria = {};

        preview = (template): void => {
            const options: Meevo.Components.Modal.IModalOptions = {
                template: `<div>${template}</div>`,
                clickOutsideToClose: true
            }

            this.modalService.showCustom(options);
        }

        businessTypeFilter = {
            criteria: this.criteria,
            sortBy: this.sort.sortBy,
            sortDirection: this.sort.sortDirection
        }

        bitToScanDateType() {
            this.scanDateTypesCheckBoxes.forEach((checkBox: ITypeScanTypeEnum, idx) => {
                const power = Math.pow(2, idx);
                if (this.model.scanDateTypeAvailableOptions & power) {
                    checkBox.checked = true;
                } else {
                    checkBox.checked = false;
                }
            })
        }

        onCheckBoxClick(checkBox): void {
            const index = this.scanDateTypesCheckBoxes.findIndex(box => box.value === checkBox.value)
            if (!this.scanDateTypeToBit()) {
                setTimeout(() => this.scanDateTypesCheckBoxes[index].checked = true, 0);
                this.modalService.alert('LABEL_ONLINEBOOKING_DATE_RANGE_MODAL_WARNING');
            }
            if (!this.scanTimeTypesCheckBoxes.some(t => t.checked)) {
                this.modalService.alert('LABEL_ONLINEBOOKING_TIME_RANGE_MODAL_WARNING').then(_ => {
                    this.scanTimeTypesCheckBoxes[0].checked = true;
                })
            }
        }


        scanDateTypeToBit(): number {
            let bitwise = 0;
            this.scanDateTypesCheckBoxes.forEach((checkBox: ITypeScanTypeEnum, idx) => {
                const power = Math.pow(2, idx);
                if (checkBox.checked === true) {
                    bitwise |= power;
                }
            })
            return bitwise;
        }

        onCheckBoxAllowEmployeeSearchClick(value): void {            
            if (this.model.anyEmployee === false && this.model.displayAnyMaleAnyFemale === false && this.model.allowSpecificEmployee === false)
            {
                if (value === "anyEmployee")
                    this.model.anyEmployee = true;
                else if (value === "displayAnyMaleAnyFemale")
                    this.model.displayAnyMaleAnyFemale = true;
                else if (value === "allowSpecificEmployee")
                    this.model.allowSpecificEmployee = true;
                this.modalService.warning('LABEL_ONLINEBOOKING_ALLOW_EMPLOYEE_SEARCH_MODAL_WARNING');
            }
            if (this.model.anyEmployee === false) {
                this.model.bypassEmployeeSection = false;
            }
        }

        preSave(): void {
            if (!this.model.onlineBookingRequireCreditCardOnFile) {
                this.model.promptCallIfCreditCardOnFileFails = false;
            }

            if (!this.model.isDepositEnabled) {
                this.model.serviceCanBypassDepositWithPrePaidPackage = false;
            }

            this.model.scanDateTypeAvailableOptions = this.scanDateTypeToBit();

            const scanTimeTypesSelected = this.scanTimeTypesCheckBoxes.filter(s => s.checked).map(s => ({ id: s.id, sortOrder: s.sortOrder, checked: s.checked, labelId: s.labelId, displayName: s.displayName }));

            this.model.scanTimeTypeAvailableOptions = angular.toJson(scanTimeTypesSelected);
            if (this.identityService.inCentralOfficeMode()) {
                if (this.model.businessTypeId == this.allBusinessTypeDetail.id) {
                    this.model.businessTypeId = null;
                }
            }
            super.preSave();
        }



        showRevertIndicatorDeposit(settingAmount: string, settingIsPercent: string, amount: any, isPercent: boolean): boolean {

            var showAmount = this.showRevertIndicator(settingAmount, '', amount);
            var showisPercent = this.showRevertIndicator(settingIsPercent, '', isPercent);

            return showAmount || showisPercent;
        }

        revertToParentDeposit(settingAmount: string, settingIsPercent: string): void {

            this.revertToParent(settingAmount, '');
            this.revertToParent(settingIsPercent, '');
           
        }

        //enum EffectiveLevelFlag {
        //  System = 0,
        //  Tenant = 1,
        //  BusinessType = 2,
        //  Location = 4
        //}
    }
}